
<h1>{{tipo=='edit' ? 'Editar' : 'Agregar'}} Centros de Costo</h1>
<form [formGroup]="form" (submit)="submit()" class="form-horizontal" novalidate>
  <fieldset>

    <div  class="form-group"  [ngClass]="{'has-error': (form.get('id_planta').touched || form.get('id_planta').dirty) && !form.get('id_planta').valid }">
      <label class="col-md-2 control-label" for="nombre">Sucursal</label>
      <div class="col-md-8">
        <input class="form-control" id="id_planta" type="text" required   formControlName="id_planta"  />
        <span class="alert alert-danger" *ngIf="(form.get('id_planta').touched || form.get('id_planta').dirty) && form.get('id_planta').errors">
          <span *ngIf="form.get('id_planta').errors.required">
            El campo ID Centro de costo es requerido
          </span>
        </span>
      </div>
    </div>

    <div  class="form-group"  [ngClass]="{'has-error': (form.get('orden_ceco').touched || form.get('orden_ceco').dirty) && !form.get('orden_ceco').valid }">
      <label class="col-md-2 control-label" for="nombre">Centro de costo</label>
      <div class="col-md-8">
        <input class="form-control" id="orden_ceco" type="text" required   formControlName="orden_ceco"  />
        <span class="alert alert-danger" *ngIf="(form.get('orden_ceco').touched || form.get('orden_ceco').dirty) && form.get('orden_ceco').errors">
          <span *ngIf="form.get('orden_ceco').errors.required">
            El campo ID Centro de costo es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('nombre_fc').touched || form.get('nombre_fc').dirty) && !form.get('nombre_fc').valid }">
      <label class="col-md-2 control-label" for="nombre">Nombre</label>
      <div class="col-md-8">
        <input class="form-control" id="nombre_fc" type="text" required   formControlName="nombre_fc" />
        <span class="alert alert-danger" *ngIf="(form.get('nombre_fc').touched || form.get('nombre_fc').dirty) && form.get('nombre_fc').errors">
          <span *ngIf="form.get('nombre_fc').errors.required">
            El campo nombre es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('descripcion').touched || form.get('descripcion').dirty) && !form.get('descripcion').valid }">
      <label class="col-md-2 control-label" for="nombre">Nombre</label>
      <div class="col-md-8">
        <input class="form-control" id="descripcion" type="text" required   formControlName="descripcion" />
        <span class="alert alert-danger" *ngIf="(form.get('descripcion').touched || form.get('descripcion').dirty) && form.get('descripcion').errors">
          <span *ngIf="form.get('descripcion').errors.required">
            El campo nombre es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('base_salario').touched || form.get('base_salario').dirty) && !form.get('base_salario').valid }">
      <label class="col-md-2 control-label" for="nombre">Nombre</label>
      <div class="col-md-8">
        <input class="form-control" id="base_salario" type="text" required   formControlName="base_salario" />
        <span class="alert alert-danger" *ngIf="(form.get('base_salario').touched || form.get('base_salario').dirty) && form.get('base_salario').errors">
          <span *ngIf="form.get('base_salario').errors.required">
            El campo nombre es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_diur').touched || form.get('v_diur').dirty) && !form.get('v_diur').valid }">
      <label class="col-md-2 control-label" for="nombre">v_diur</label>
      <div class="col-md-8">
        <input class="form-control" id="v_diur" type="text" required   formControlName="v_diur" />
        <span class="alert alert-danger" *ngIf="(form.get('v_diur').touched || form.get('v_diur').dirty) && form.get('v_diur').errors">
          <span *ngIf="form.get('v_diur').errors.required">
            El campo v_diur es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_noc').touched || form.get('v_noc').dirty) && !form.get('v_noc').valid }">
      <label class="col-md-2 control-label" for="nombre">v_noc</label>
      <div class="col-md-8">
        <input class="form-control" id="v_noc" type="text" required   formControlName="v_noc" />
        <span class="alert alert-danger" *ngIf="(form.get('v_noc').touched || form.get('v_noc').dirty) && form.get('v_noc').errors">
          <span *ngIf="form.get('v_noc').errors.required">
            El campo v_noc es requerido
          </span>
        </span>
      </div>
    </div>



    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_fes_d').touched || form.get('v_fes_d').dirty) && !form.get('v_fes_d').valid }">
      <label class="col-md-2 control-label" for="v_fes_d">v_fes_d</label>
      <div class="col-md-8">
        <input class="form-control" id="v_fes_d" type="text" required   formControlName="v_fes_d" />
        <span class="alert alert-danger" *ngIf="(form.get('v_fes_d').touched || form.get('v_fes_d').dirty) && form.get('v_fes_d').errors">
          <span *ngIf="form.get('v_fes_d').errors.required">
            El campo v_fes_d es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_fes_n').touched || form.get('v_fes_n').dirty) && !form.get('v_fes_n').valid }">
      <label class="col-md-2 control-label" for="v_fes_n">v_fes_n</label>
      <div class="col-md-8">
        <input class="form-control" id="v_fes_n" type="text" required   formControlName="v_fes_n" />
        <span class="alert alert-danger" *ngIf="(form.get('v_fes_n').touched || form.get('v_fes_n').dirty) && form.get('v_fes_n').errors">
          <span *ngIf="form.get('v_fes_n').errors.required">
            El campo v_fes_n es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_diur_ext').touched || form.get('v_diur_ext').dirty) && !form.get('v_diur_ext').valid }">
      <label class="col-md-2 control-label" for="v_diur_ext">v_diur_ext</label>
      <div class="col-md-8">
        <input class="form-control" id="v_diur_ext" type="text" required   formControlName="v_diur_ext" />
        <span class="alert alert-danger" *ngIf="(form.get('v_diur_ext').touched || form.get('v_diur_ext').dirty) && form.get('v_diur_ext').errors">
          <span *ngIf="form.get('v_diur_ext').errors.required">
            El campo v_diur_ext es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_noc_ext').touched || form.get('v_noc_ext').dirty) && !form.get('v_noc_ext').valid }">
      <label class="col-md-2 control-label" for="v_noc_ext">v_noc_ext</label>
      <div class="col-md-8">
        <input class="form-control" id="v_noc_ext" type="text" required   formControlName="v_noc_ext" />
        <span class="alert alert-danger" *ngIf="(form.get('v_noc_ext').touched || form.get('v_noc_ext').dirty) && form.get('v_noc_ext').errors">
          <span *ngIf="form.get('v_noc_ext').errors.required">
            El campo v_noc_ext es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_fes_d_ext').touched || form.get('v_fes_d_ext').dirty) && !form.get('v_fes_d_ext').valid }">
      <label class="col-md-2 control-label" for="v_fes_d_ext">v_fes_d_ext</label>
      <div class="col-md-8">
        <input class="form-control" id="v_fes_d_ext" type="text" required   formControlName="v_fes_d_ext" />
        <span class="alert alert-danger" *ngIf="(form.get('v_fes_d_ext').touched || form.get('v_fes_d_ext').dirty) && form.get('v_fes_d_ext').errors">
          <span *ngIf="form.get('v_fes_d_ext').errors.required">
            El campo v_fes_d_ext es requerido
          </span>
        </span>
      </div>
    </div>


    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_fes_n_ext').touched || form.get('v_fes_n_ext').dirty) && !form.get('v_fes_n_ext').valid }">
      <label class="col-md-2 control-label" for="nombre">v_fes_n_ext</label>
      <div class="col-md-8">
        <input class="form-control" id="v_fes_n_ext" type="text" required   formControlName="v_fes_n_ext" />
        <span class="alert alert-danger" *ngIf="(form.get('v_fes_n_ext').touched || form.get('v_fes_n_ext').dirty) && form.get('v_fes_n_ext').errors">
          <span *ngIf="form.get('v_fes_n_ext').errors.required">
            El campo v_fes_n_ext es requerido
          </span>
        </span>
      </div>
    </div>

    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_f_d_s_c').touched || form.get('v_f_d_s_c').dirty) && !form.get('v_f_d_s_c').valid }">
      <label class="col-md-2 control-label" for="v_f_d_s_c">v_f_d_s_c</label>
      <div class="col-md-8">
        <input class="form-control" id="v_f_d_s_c" type="text" required   formControlName="v_f_d_s_c" />
        <span class="alert alert-danger" *ngIf="(form.get('v_f_d_s_c').touched || form.get('v_f_d_s_c').dirty) && form.get('v_f_d_s_c').errors">
          <span *ngIf="form.get('v_f_d_s_c').errors.required">
            El campo v_f_d_s_c es requerido
          </span>
        </span>
      </div>
    </div>



    <div class="form-group"  [ngClass]="{'has-error': (form.get('v_f_n_s_c').touched || form.get('v_f_n_s_c').dirty) && !form.get('v_f_n_s_c').valid }">
      <label class="col-md-2 control-label" for="v_f_n_s_c">v_f_n_s_c</label>
      <div class="col-md-8">
        <input class="form-control" id="v_f_n_s_c" type="text" required   formControlName="v_f_n_s_c" />
        <span class="alert alert-danger" *ngIf="(form.get('v_f_n_s_c').touched || form.get('v_f_n_s_c').dirty) && form.get('v_f_n_s_c').errors">
          <span *ngIf="form.get('v_f_n_s_c').errors.required">
            El campo v_f_n_s_c es requerido
          </span>
        </span>
      </div>
    </div>




    <div class="form-group">
      <div class="col-md-4 col-md-offset-2">
        <span>
          <button class="btn btn-primary"   [disabled]="!form.valid"> Salvar  </button>
          <button class="btn btn-primary" (click)="closeMyModal(false)">Cerrar Modal</button>

        </span>

      </div>

    </div>
  </fieldset>
</form>


